export const vitalSigns = [
  { name: 'personalMedicalHistory', translationKey: 'Historia Medica Personal' },
  { name: 'familiarMedicalHistory', translationKey: 'Historia Medica Familiar' },
  { name: 'symptoms', translationKey: 'Sintomas' },
  { name: 'signs', translationKey: 'Signos' },
  { name: 'age', translationKey: 'Edad' },
  { name: 'homeAdress', translationKey: 'Direccion de Domicilio' },
  { name: 'recentTrips', translationKey: 'Viajes Recientes' },
  { name: 'weight', translationKey: 'Peso' },
  { name: 'height', translationKey: 'Altura' },
  { name: 'temperatura', translationKey: 'Temperatura Corporal' },
  { name: 'pulse', translationKey: 'Frecuencia Cardiaca' },
  { name: 'breathesPerMinute', translationKey: 'Respiraciones por Minuto' },
  { name: 'pressure', translationKey: 'Presion Sanguinea' },
  { name: 'oxygenSaturation', translationKey: 'Saturacion de Oxigeno' },
];

export const laboratoryExams = [
  { name: 'Na', translationKey: 'Examen de Sodio en la Sangre' },
  { name: 'K', translationKey: 'Examen de Potasio en la Sangre' },
  { name: 'Cl', translationKey: 'Examen de Cloruro en la Sangre' },
  { name: 'WBC', translationKey: 'Conteo de Glóbulos Blancos' },
  { name: 'HCT', translationKey: 'Analisis de Hematocrito' },
  { name: 'bakingSoda', translationKey: 'Examen de CO2 en la Sangre' },
  { name: 'BUN', translationKey: 'Examen de Nitrogeno de Urea en la Sangre' },
  { name: 'glukose', translationKey: 'Examen de Glucosa en la Sangre' },
  { name: 'platelets', translationKey: 'Conteo de Plaquetas en la Sangre' },
  { name: 'creatinine', translationKey: 'Examen de Creatinina en la Sangre' },
  { name: 'hepaticFunctionality', translationKey: 'Examenes de Funcionalidad Hepatica' },
  { name: 'renalFunctionality', translationKey: 'Examenes de Funcionalidad Renal' },
  { name: 'specials', translationKey: 'Examenes Especiales' },
];

export const radiologicalExams = [
  { name: 'ultrasound', translationKey: 'Resultados de Ultrasonido' },
  { name: 'xRays', translationKey: 'Resultados de Rayos-X' },
  { name: 'tomography', translationKey: 'Resultados de Tomografia' },
  { name: 'resonancia', translationKey: 'Resultados de Resonancia Magnetica' },
];

export const diagnosis = [{ name: 'diagnosis', translationKey: 'Diagnostico' }];

export const clinicalTreatment = [
  { name: 'treatmentDays', translationKey: 'Dias de Tratamiento' },
  { name: 'treatmentMedications', translationKey: 'Medicamentos para Tratamiento' },
];

export const surgicalTreatment = [
  { name: 'surgicalTreatmentDays', translationKey: 'Dias de Tratamiento' },
  { name: 'treatmentProcedures', translationKey: 'Procedimientos en Tratamiento' },
];
